import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"

export default styled(Box)(() => ({
  display: "flex",
}))
